import { styled } from '@peoplecues/commons';
import { dim } from 'styles/theme';

export const getAllMargins = props => {
  const { m, mh, mv, mt, mr, mb, ml } = props;
  if (!(m || mh || mv || mt || mr || mb || ml)) return '';
  if (m) return `margin: ${dim._scale(m)};`;
  if (mh || mv) return `margin: ${dim._scale(mv || 0)} ${dim._scale(mh || 0)};`;
  let value = '';
  if (mt) value = value.concat(`margin-top: ${dim._scale(mt)};`);
  if (mr) value = value.concat(`margin-right: ${dim._scale(mr)};`);
  if (mb) value = value.concat(`margin-bottom: ${dim._scale(mb)};`);
  if (ml) value = value.concat(`margin-left: ${dim._scale(ml)};`);
  return value;
};

export const getAllPaddings = props => {
  const { p, pv, ph, pt, pr, pb, pl } = props;
  if (!(p || pv || ph || pt || pr || pb || pl)) return '';
  if (p) return `padding: ${dim._scale(p)};`;
  if (pv || ph)
    return `padding: ${dim._scale(pv || 0)} ${dim._scale(ph || 0)};`;
  let value = '';
  if (pt) value = value.concat(`padding-top: ${dim._scale(pt)};`);
  if (pr) value = value.concat(`padding-right: ${dim._scale(pr)};`);
  if (pb) value = value.concat(`padding-bottom: ${dim._scale(pb)};`);
  if (pl) value = value.concat(`padding-left: ${dim._scale(pl)};`);
  return value;
};

const calculateWidth = props => {
  const { p, ph, pr, pl } = props;
  const padding =
    (p && dim._scale(p * 2)) ||
    0 ||
    (ph && dim._scale(ph * 2)) ||
    0 ||
    ((pl && dim._scale(pl)) || 0) + ((pr && dim._scale(pr)) || 0);
  return padding ? `calc(100% - ${padding})` : '100%';
};

export const Text = styled.div`
  font-size: ${props =>
    props.fontSize ? dim._scale(props.fontSize) : dim._14px};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
  line-height: ${props =>
    (props.lineHeight && dim._scale(props.lineHeight)) ||
    dim._scale((props.fontSize || 14) * 1.5)};
  letter-spacing: ${props =>
    props.letterSpacing ? dim._scale(props.letterSpacing) : 'normal'};
  color: ${props =>
    props.color
      ? props.theme.color[props.color] || props.color
      : props.theme.color.base_10};
  ${props => getAllMargins(props)};
  ${props => getAllPaddings(props)};
  ${props =>
    props.secondaryText
      ? `
      &::after {
        content: ${`"${props.secondaryText}"`};
        ${
          props.secondaryTextLeftPadding
            ? `padding-left: ${dim._scale(props.secondaryTextLeftPadding)}`
            : ''
        };
        font-weight: ${props.secondaryTextfontWeight};
        ${
          props.secondaryTextColor
            ? `color:  ${
                props.theme.color[props.secondaryTextColor] ||
                props.secondaryTextColor
              }`
            : ''
        };
      }
    `
      : ''};
  ${props => (props.cursor ? `cursor: ${props.cursor}` : '')};
  ${props =>
    props.height
      ? `height: ${
          typeof props.height === 'string'
            ? props.height
            : dim._scale(props.height)
        }`
      : ''};
  ${props =>
    props.width
      ? `width: ${
          typeof props.width === 'string'
            ? props.width
            : dim._scale(props.width)
        }`
      : ''};
  ${props =>
    props.maxWidth
      ? `max-width: ${
          typeof props.maxWidth === 'string'
            ? props.maxWidth
            : dim._scale(props.maxWidth)
        }`
      : ''};
  ${props => (props.overflow ? `overflow: ${props.overflow}` : '')};
  ${props =>
    props.textOverflow ? `text-overflow: ${props.textOverflow}` : ''};
  ${props => (props.whiteSpace ? `white-space: ${props.whiteSpace}` : '')};
  ${props => (props.display ? `display: ${props.display}` : '')};
  ${props => (props.float ? `float: ${props.float}` : '')};
  span.bold {
    font-weight: 600;
  }
  span.normal {
    float: left;
    display: block;
    width: fit-content;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  ${props =>
    props.flexDirection
      ? `flex-direction: ${props.flexDirection}`
      : 'flex-direction: row'};
  ${props =>
    props.alignItems
      ? `align-items: ${props.alignItems}`
      : 'align-items: center'};
  ${props =>
    props.justifyContent ? `justify-content: ${props.justifyContent}` : ''};
  ${props =>
    props.height
      ? `height: ${
          typeof props.height === 'string'
            ? props.height
            : dim._scale(props.height)
        }`
      : ''};
  ${props =>
    props.width
      ? `width: ${
          typeof props.width === 'string'
            ? props.width
            : dim._scale(props.width)
        }`
      : ''};
  ${props => (props.useFullWidth ? `width: ${calculateWidth(props)}` : '')};
  ${props => (props.flex ? `flex: ${props.flex}` : '')};
  ${props =>
    props.backgroundColor
      ? `background-color: ${props.theme.color[props.backgroundColor]}`
      : ''};
  ${props => getAllMargins(props)};
  ${props => getAllPaddings(props)};
  ${props => (props.cursor ? `cursor: ${props.cursor}` : '')};
  ${props => (props.overflowX ? `overflow-x: ${props.overflowX}` : '')};
  & > :not(:first-child) {
    ${props =>
      props.secondItemLeftPadding
        ? `padding-left: ${dim._scale(props.secondItemLeftPadding)}`
        : 0};
    ${props =>
      props.secondItemLeftMargin
        ? `margin-left: ${dim._scale(props.secondItemLeftMargin)}`
        : 0};
  }
`;

export const Tab = styled.div.attrs({ className: 'no-user-select' })`
  position: relative;
  border-radius: ${dim._4px};
  background-color: ${props =>
    props.active
      ? props.theme.color.highlights_blue
      : props.theme.color.base_100};
  padding: ${dim._8px};
  font-size: ${dim._14px};
  line-height: ${dim._16px};
  color: ${props =>
    props.active ? props.theme.color.blue_50 : props.theme.color.text_normal};
  font-weight: ${props => (props.active ? 600 : 500)};
  ${props => getAllMargins(props)};
  cursor: pointer;
`;

export const Chip = styled.div.attrs({ className: 'no-user-select' })`
  border-radius: ${dim._2px};
  background-color: ${props => props.theme.color.highlights_blue};
  padding: ${props => (props.small ? '2px 6px' : '4px 7px')};
  font-size: ${dim._12px};
  font-weight: 500;
  line-height: ${dim._18px};
  letter-spacing: 0.24px;
  color: ${props => props.theme.color.blue_20};
  ${props => getAllMargins(props)};
  ${props =>
    props.isNonAlignedObjective
      ? `color: ${props.theme.color.yellow_20};
        background-color: ${props.theme.color.yellow_80};
        `
      : ''};
`;
